
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kai-zen-strategy",
      function () {
        return require("private-next-pages/kai-zen-strategy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kai-zen-strategy"])
      });
    }
  